import axios from "axios";
import { paramsConfig } from "../utils/paramsUtils";
import { IImportExcel } from "../components/export-excel/models/excelModels";
import { localStorageItem } from "../utils/localStorage";
import { KEY_LOCALSTORAGE } from "../auth/core/_consts";

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL;

export const fileUpload = (file: any, type: string) => {
  let url = `${API_PATH}/file/upload`;
  let formData = new FormData();
  formData.append("uploadFile", file);
  formData.append("type", type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(url, formData, config);
};
export const imageUpload = (file: any, type: string) => {
  let url = `${API_PATH}/file/upload-image`;
  let formData = new FormData();
  formData.append("uploadImage", file);
  formData.append("type", type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(url, formData, config);
};
export const downLoadFile = (fileName: string) => {
  let url = `${API_PATH}/file/document?fileName=${fileName}`;
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downLoadFileById = (fileId: string) => {
  let url = `${API_PATH}/file/document/${fileId}`;
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};


export const getTemplateFile = (searchObject: any) => {
  const url = `${API_PATH}/api/v1/tool/read-excel`;
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
    ...paramsConfig(searchObject)
  });
};

export const getErrorFile = (searchObject: any) => {
  const url = `${API_PATH}/api/v1/tool/download`;
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
    ...paramsConfig(searchObject)
  });
};

export const importFile = (params: IImportExcel) => {
  const url = `${API_PATH}/api/v1/tool/import-data`;
  const formData = new FormData();

  for (const key in params) {
    if(params.hasOwnProperty(key)) {
      const value = (params as any)[key];
      if(value !== null && value !== undefined) {
        formData.append(key, value);
      }
    }
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  
  return axios.post(url, formData, config);
};